import React from "react";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { baseURL } from "../../Config/config";

const EditModal = (props) => {
  const navigate = useNavigate();

  const [projectName, setProjectName] = React.useState(sessionStorage.getItem("editprojectName"));
  const [clientname, setClientName] = React.useState(sessionStorage.getItem("editclientname"));
  const [objective, setObjective] = React.useState(sessionStorage.getItem("editobjective"));
  const [isLoading, setIsLoading] = React.useState(false);
  const [getLoader, setGetLoader] = React.useState(false);
  const [err, seterr] = React.useState("");
  // const createNewProject = async () => {
  //   navigate("/newproject");
  // }
  
   
  console.log("props",props)


 return (
  <Modal
    open={props.isModal}
    onClose={props.handleeditClose}
    aria-labelledby="modal-modal-title"
  >
    <Box
      sx={{
        width: 380,
        bgcolor: "#fff",
        borderRadius: "22px",
        p: 3,
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        boxShadow: "0px 12px 40px rgba(0,0,0,.15)",
        border: "1px solid #d9e9f7",
      }}
    >
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: 700,
          color: "#0078c9",
          mb: 0.5,
        }}
      >
        Edit Project
      </Typography>

      <Typography sx={{ fontSize: "12px", color: "#666", mb: 2 }}>
        Update project details.
      </Typography>

      {[
        {
          label: "Project Name",
          defaultValue: props.editProjectName,
          onChange: (e) => props.setEditProjectName(e.target.value),
        },
        {
          label: "Client Name",
          defaultValue: props.editClientName,
          onChange: (e) => props.setEditClientName(e.target.value),
          optional: true,
        },
        {
          label: "Objective",
          defaultValue: props.editObjective,
          onChange: (e) => props.setEditObjective(e.target.value),
          optional: true,
        },
      ].map((field, i) => (
        <Box key={i} sx={{ mb: 1.6 }}>
          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: 600,
              color: "#444",
              mb: 0.6,
            }}
          >
            {field.label} {field.optional ? "(Optional)" : ""}
          </Typography>

          <TextField
            fullWidth
            size="small"
            variant="outlined"
            defaultValue={field.defaultValue}
            onChange={field.onChange}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
                fontSize: "14px",
                height: 40,
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#d9e9f7",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#9e0b22",
              },
              "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#0078c9",
              },
            }}
          />
        </Box>
      ))}

      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
        {isLoading ? (
          <CircularProgress size={28} sx={{ color: "#0078c9" }} />
        ) : (
          <Button
            onClick={props.handleEditProject}
            variant="contained"
            sx={{
              height: 40,
              px: 3,
              fontSize: "12px",
              fontWeight: 600,
              borderRadius: "12px",
              textTransform: "none",
              background: "linear-gradient(90deg,#0078c9,#0d8fe6)",
              boxShadow: "0px 8px 18px rgba(0,120,201,.25)",
              "&:hover": {
                background: "#9e0b22",
              },
            }}
          >
            Continue
          </Button>
        )}
      </Box>
    </Box>
  </Modal>
);
};

export default EditModal;
